import PolicyEdit from './PolicyEdit';
import PolicyList from './PolicyList';
import TermsSettingsPage from './TermsSettingsPage';
import ExtensionData from './ExtensionData';

export const components = {
  PolicyEdit,
  PolicyList,
  TermsSettingsPage,
  ExtensionData,
};
